module.exports = __webpack_public_path__ + "static/media/lifestyle-icon-default.83d59c57.svg";